const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^[\d\s()+\-]{6,20}$/;

export const validateContactForm = (values) => {
  const errors = {};

  const setError = (field, message) => {
    if (!errors[field]) {
      errors[field] = message;
    }
  };

  if (!values.firstName?.trim()) {
    setError('firstName', 'First name is required.');
  }

  if (!values.lastName?.trim()) {
    setError('lastName', 'Last name is required.');
  }

  if (!values.email?.trim()) {
    setError('email', 'Email is required.');
  } else if (!EMAIL_PATTERN.test(values.email.trim())) {
    setError('email', 'Please enter a valid email address.');
  }

  if (!values.countryCode?.trim()) {
    setError('countryCode', 'Country code is required.');
  }

  if (!values.phone?.trim()) {
    setError('phone', 'Phone number is required.');
  } else if (!PHONE_PATTERN.test(values.phone.trim())) {
    setError('phone', 'Please enter a valid phone number.');
  }

  if (!values.message?.trim()) {
    setError('message', 'Message is required.');
  } else if (values.message.trim().length > 5000) {
    setError('message', 'Message must be 5000 characters or fewer.');
  }

  if (!values.agreed) {
    setError('privacyPolicy', 'You must agree to the privacy policy.');
  }

  const messages = Object.values(errors);

  return {
    errors,
    messages,
    isValid: messages.length === 0,
  };
};
